import React from "react";

// To transfer values between table and toolbar (values for filtering data in the table)
export const UserToolbarContext = React.createContext(undefined);
